mutation RemoveAudienceMembership($input: AudienceMemberDeleteInput!) {
    audienceMemberDelete(input: $input) {
        audienceMember {
            id
        }
    }
}
